var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderlogo08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140px",
    height: "50px",
    viewBox: "0 0 140 50",
    enableBackground: "new 0 0 140 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 1.333,
    width: 140,
    height: 46.667
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 0,
    y: 1.333,
    width: 140,
    height: 46.667
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M65.668,23.978c0,2.914-2.37,5.283-5.282,5.283h-7.053 c-2.913,0-5.283-2.369-5.283-5.283V7.032h-3.467v16.946c0,4.825,3.925,8.75,8.75,8.75h7.053c4.825,0,8.75-3.926,8.75-8.75V7.032 h-3.467V23.978z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M90.782,7H72.239l2.479,3.467h16.063c1.425,0,2.583,1.159,2.583,2.582v3.059 c0,1.424-1.158,2.583-2.583,2.583H80.547l10.604,14.043h4.266L87.385,22.11l3.397-0.008c3.337,0,6.05-2.714,6.05-6.05V13.05 C96.832,9.714,94.119,7,90.782,7"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M23.966,7.041h-0.005c-1.357,0.001-2.579,0.699-3.271,1.865L6.368,32.734 h4.046l5.509-9.166h8.483h0.639h2.106l-2.072-3.468h-0.034h-0.038h-7l5.659-9.414c0.002-0.004,0.004-0.008,0.007-0.012 c0.065-0.111,0.164-0.167,0.293-0.167h0c0.129,0,0.227,0.056,0.295,0.171L37.44,32.734h4.039L27.24,8.904 C26.547,7.737,25.324,7.041,23.966,7.041"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M119.394,8.904c-0.692-1.167-1.917-1.864-3.273-1.864h-0.006 c-1.356,0.002-2.578,0.699-3.271,1.865L98.522,32.734h4.045l5.509-9.166h8.483h0.638h2.106l-2.071-3.467h-0.035h-0.038h-6.999 l5.659-9.415c0.002-0.004,0.004-0.007,0.007-0.012c0.065-0.111,0.164-0.167,0.293-0.167h0.001c0.128,0,0.227,0.056,0.295,0.17 l13.179,22.056h4.038L119.394,8.904z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M42.657,41.169v-0.251c0-0.073,0.039-0.11,0.116-0.11h0.375 c0.077,0,0.116,0.037,0.116,0.11v0.204c0,0.472,0.247,0.707,0.74,0.707h0.732c0.493,0,0.74-0.24,0.74-0.723V40.84 c0-0.378-0.33-0.624-0.99-0.739c-0.277-0.047-0.555-0.102-0.832-0.165c-0.277-0.063-0.513-0.185-0.707-0.365 c-0.194-0.181-0.291-0.428-0.291-0.742v-0.385c0-0.361,0.109-0.646,0.328-0.853c0.219-0.207,0.52-0.311,0.902-0.311h0.923 c0.377,0,0.677,0.104,0.898,0.311s0.333,0.491,0.333,0.853v0.196c0,0.078-0.036,0.117-0.108,0.117h-0.383 c-0.072,0-0.108-0.039-0.108-0.117v-0.142c0-0.477-0.247-0.715-0.74-0.715h-0.707c-0.494,0-0.74,0.249-0.74,0.746v0.314 c0,0.267,0.186,0.45,0.557,0.55c0.167,0.042,0.35,0.08,0.549,0.114c0.2,0.034,0.401,0.078,0.603,0.134 c0.203,0.055,0.387,0.123,0.553,0.204c0.167,0.081,0.301,0.204,0.403,0.369s0.154,0.365,0.154,0.601v0.354 c0,0.362-0.111,0.646-0.333,0.853c-0.222,0.207-0.521,0.311-0.898,0.311h-0.957c-0.377,0-0.676-0.104-0.898-0.311 C42.768,41.815,42.657,41.531,42.657,41.169"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M51.972,42.332h-0.374c-0.078,0-0.117-0.036-0.117-0.109v-4.832 c0-0.073,0.039-0.11,0.117-0.11h0.374c0.078,0,0.117,0.037,0.117,0.11v2.71h0.025c0.039-0.109,0.1-0.217,0.183-0.322l1.863-2.388 c0.05-0.073,0.122-0.11,0.216-0.11h0.449c0.094,0,0.108,0.039,0.042,0.118l-1.646,2.105l1.879,2.702 c0.061,0.084,0.036,0.126-0.075,0.126h-0.341c-0.116,0-0.197-0.036-0.241-0.109l-1.597-2.303l-0.757,0.856v1.446 C52.089,42.296,52.05,42.332,51.972,42.332"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M61.712,42.332h-0.374c-0.078,0-0.117-0.036-0.117-0.109v-1.784l-1.58-3.04 c-0.017-0.037-0.017-0.065,0-0.087c0.017-0.021,0.042-0.031,0.075-0.031h0.466c0.061,0,0.108,0.037,0.142,0.11l1.189,2.38h0.042 l1.181-2.38c0.022-0.073,0.067-0.11,0.133-0.11h0.474c0.094,0,0.119,0.039,0.075,0.118l-1.588,3.04v1.784 C61.829,42.296,61.79,42.332,61.712,42.332"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M68.907,42.332h-0.375c-0.078,0-0.116-0.036-0.116-0.109v-4.832 c0-0.073,0.039-0.11,0.116-0.11h1.947c0.382,0,0.682,0.104,0.898,0.311s0.324,0.491,0.324,0.853v0.872 c0,0.366-0.108,0.651-0.324,0.856c-0.216,0.204-0.516,0.306-0.898,0.306h-1.373c-0.056,0-0.083,0.024-0.083,0.071v1.674 C69.023,42.296,68.984,42.332,68.907,42.332 M69.106,39.967h1.289c0.466,0,0.698-0.225,0.698-0.675v-0.825 c0-0.456-0.232-0.684-0.698-0.684h-1.289c-0.056,0-0.083,0.023-0.083,0.07v2.043C69.023,39.943,69.051,39.967,69.106,39.967"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M79.079,42.332h-0.99c-0.383,0-0.684-0.102-0.902-0.307 c-0.219-0.204-0.328-0.489-0.328-0.856v-2.726c0-0.367,0.109-0.652,0.328-0.856s0.52-0.307,0.902-0.307h0.99 c0.382,0,0.683,0.104,0.902,0.311c0.219,0.207,0.328,0.491,0.328,0.853v2.726c0,0.361-0.109,0.646-0.328,0.853 C79.762,42.229,79.461,42.332,79.079,42.332 M78.155,41.829h0.849c0.466,0,0.698-0.228,0.698-0.684v-2.679 c0-0.456-0.232-0.684-0.698-0.684h-0.849c-0.46,0-0.69,0.228-0.69,0.684v2.679C77.465,41.602,77.695,41.829,78.155,41.829"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M87.828,42.332h-0.989c-0.383,0-0.684-0.102-0.902-0.307 c-0.219-0.204-0.328-0.489-0.328-0.856v-2.726c0-0.367,0.109-0.652,0.328-0.856s0.52-0.307,0.902-0.307h0.989 c0.383,0,0.684,0.104,0.903,0.311c0.219,0.207,0.328,0.491,0.328,0.853v2.726c0,0.361-0.109,0.646-0.328,0.853 C88.512,42.229,88.211,42.332,87.828,42.332 M86.905,41.829h0.849c0.466,0,0.698-0.228,0.698-0.684v-2.679 c0-0.456-0.232-0.684-0.698-0.684h-0.849c-0.46,0-0.69,0.228-0.69,0.684v2.679C86.215,41.602,86.445,41.829,86.905,41.829"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M97.228,42.332h-2.67c-0.078,0-0.117-0.036-0.117-0.109v-4.832 c0-0.073,0.039-0.11,0.117-0.11h0.374c0.077,0,0.116,0.037,0.116,0.11v4.353c0,0.047,0.028,0.07,0.083,0.07h2.097 c0.077,0,0.116,0.039,0.116,0.118v0.291C97.344,42.296,97.305,42.332,97.228,42.332"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderlogo08);
export default __webpack_public_path__ + "static/media/providerlogo08.80448f0a38fd86a35aaec1985ccaa616.svg";
export { ForwardRef as ReactComponent };